import {formatOpts} from './formats'

export generate = (bundle, opts) ->
  bundle.generate formatOpts opts
